export type MenuItem = {
  text: string;
  path: string;
  name: string;
  highlight?: boolean;
};

const useMenu = () => {
  const menuItems: MenuItem[] = [
    { text: "Sites", path: "/sites", name: "sites" },
    { text: "Lojas Virtuais", path: "/lojas-virtuais", name: "lojas-virtuais" },
    { text: "Sistemas", path: "/sistemas", name: "sistemas" },
    { text: "Marketing", path: "/marketing", name: "marketing" },
  ];

  //MOBILE
  const menuItemsMobile: MenuItem[] = [
    { text: "Serviços", path: "/", name: "servicos" },
    { text: "Sites", path: "/sites", name: "sites" },
    { text: "Lojas Virtuais", path: "/lojas-virtuais", name: "lojas-virtuais" },
    { text: "Sistemas", path: "/sistemas", name: "sistemas" },
    {
      text: "Marketing",
      path: "/marketing",
      name: "marketing",
    },
  ];

  return {
    menuItems,
    menuItemsMobile,
  };
};

export default useMenu;
